import React from 'react';
import {
  SmartButton,
  SmartFormLabel,
  SmartScanner,
  SmartSpace,
} from 'components/Sales/Smart/SmartComponent';
import {
  message,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  //COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  //HTTP_STATUS_OK,
} from 'constants/config';
import {
  //editWarehousePostedTransfer,
  //fetchWarehousePostedTransferDetail,
  //fetchWarehousePostedTransferDetailByBatchNumber,
  fetchWarehouseTransferList,
} from 'services/inventory';
import { playSound } from 'utils';
import BatchSelectorDrawer from './BatchSelectorDrawer';
import { WHTActionType as WHTAction, WMSRecvStep } from './context';

type Props = ReduxStateProps & {
};

const ScanBatch = (props: Props) => {
  const { useState } = React;
  const [isBatchSelectorVisible, setIsBatchSelectorVisible] = useState(false);

  const closeBatchSelectorDrawer = () => {
    setIsBatchSelectorVisible(false);
  };

  const handleScannerChange = async (val: string) => {
    const { dispatch, state } = props;
    const bn = val.trim();

    if (!bn) return;
    console.log('v', val);
    playSound('bell');
    dispatch({ type: WHTAction.SetLockScreen, params: true });
    try {
      const queryparams = {
        $skip: 0,
        $top: 10,
        //transferStatus: 0,
        statusList: [0, 1],
        transferType: 0,
        $sortBy: 'TransferNum desc',
        batchNumber: bn,
      };
      const { /*count,*/ data } = await fetchWarehouseTransferList(
        state.selectedWarehouse.warehouseId,
        queryparams,
      );
      console.log('t', data);
      if (Array.isArray(data)) {
        if (data.length === 1) {
          setSelectedBatch(data[0]);
          dispatch({ type: WHTAction.SetWMSRecvStep, params: WMSRecvStep.ScanLocation });
        } else {
          playSound('error');
          message.error({
            content: `Found ${data.length} batch(s) with ${bn}`,
            duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
          });
        }
      } else {
        playSound('error');
        message.error({
          content: 'Data format error',
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
      }
    } catch(e) {
      playSound('error');
      message.error({
        content: `Loaded batch error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      dispatch({ type: WHTAction.SetLockScreen, params: false });
    }
  };

  const openBatchSelectorDrawer = () => {
    setIsBatchSelectorVisible(true);
  };

  const onSelectBatch = (batch: StringKAnyVPair) => {
    batch.batchNumber && handleScannerChange(batch.batchNumber);
  };

  const setSelectedBatch = (batch: StringKAnyVPair) => {
    const { dispatch } = props;

    dispatch({ type: WHTAction.SetCurrentWMSBatch, params: batch });
  };

  return (<>
    <SmartSpace>
      <SmartFormLabel className="fs-18 mb-10 text-bold2 text-green-label">Scan Batch # to start</SmartFormLabel>
      <SmartScanner
        //disabled={isFetching}
        isAutoFocus={1}
        placeholder="Input Batch # here"
        onChangeValue={handleScannerChange}
      />
      <SmartButton
        className="mt-30"
        onClick={openBatchSelectorDrawer}
        size="large"
        //style={{marginBottom: 0}}
        type="primary"
      >
        Select Batch # from list
      </SmartButton>
    </SmartSpace>
    {isBatchSelectorVisible && (
      <BatchSelectorDrawer
        dispatch={props.dispatch}
        onClose={closeBatchSelectorDrawer}
        onSelect={onSelectBatch}
        state={props.state}
        visible={isBatchSelectorVisible}
      />
    )}
  </>);
};

export default ScanBatch;
